import { IObject } from "@quest/base-core";
import { reelPanel, slot } from "@quest/slot-core";
import { BehaviorCoreModule } from "@quest/murka-games-behavior-panther/dist";

//  BASE GAME
import { BaseControllerGame } from "./Base/BaseControllerGame";
import { BaseGameViewGame } from "./Base/BaseGameViewGame";
import { MetersControllerGame } from "./Base/MetersControllerGame";
import { ButtonControllerGame } from "./Base/ButtonControllerGame";
import { ReelPanelControllerGame } from "./Base/ReelPanelControllerGame";
import { WinPresentationControllerGame } from "./Base/WinPresentationControllerGame";
import { BaseGameModel } from "./model/BaseGameModel";
import { FreeGameModel } from "./model/FreeGameModel";
import { GameClientLogic } from "./Logic/GameClientLogic";
import { gameConstants } from "./Constants/gameConstants";
import { SettingPanelController } from "./Base/SettingPanelController";
import { PostLoadingControllerGame } from "./PostLoading/PostLoadingControllerGame";
import { GameIntroControllerGame } from "./GameIntro/GameIntroControllerGame";

//  INTRO OUTRO
import { IntroOutroControllerGame } from "./IntroOutro/IntroOutroControllerGame";

// BIG WIN
import { BigWinControllerFgGame } from "./BigWin/BigWinControllerFgGame";

// FREE GAME
import { View } from "./FreeGame/View";
import { FreeGameControllerGame } from "./FreeGame/FreeGameControllerGame";
import { FreeGameMetersControllerGame } from "./FreeGame/FreeGameMetersControllerGame";
import { FreeGameReelPanelControllerGame } from "./FreeGame/FreeGameReelPanelController";
import { BackgroundControllerGame } from "./Background/BackgroundControllerGame";
import { FreeGameWinPresentationControllerGame } from "./FreeGame/FreeGameWinPresentationControllerGame";
import { ReelGame } from "./ReelPanel/Reel";
import { WinPresentationPanelGame } from "./ReelPanel/WinPresentationPanel";
import { BigWinViewGame } from "./BigWin/BigWinViewGame";
import { BigWinControllerGame } from "./BigWin/BigWinControllerGame";
import { FreeGameRetriggerController } from "./FreeGameRetrigger/FreeGameRetriggerController";
import { FreeGameRetriggerView } from "./FreeGameRetrigger/FreeGameRetriggerView";
import { PlayerMsgControllerGame } from "./playermessage/PlayerMsgControllerGame";
import { BlurBackgroundControllerGame } from "./BlurBackground/BlurBackgroundController";
import { TopLogoViewGame } from "./TopLogo/TopLogoViewGame";
import { TopLogoViewfgGame } from "./TopLogo/TopLogoViewfgGame";
import { TopLogoControllerFgGame } from "./TopLogo/TopLogoControllerFgGame";
import { IntroOutroViewGame } from "./IntroOutro/IntroOutroViewGame";

// This is only for adding coreModuleList in final game js else use gameConstants directly//
export let game: IObject = {
  gameConstants: gameConstants,
};

BehaviorCoreModule.GameIntroController = GameIntroControllerGame;
BehaviorCoreModule.FreeGameController = FreeGameControllerGame;
BehaviorCoreModule.FreeGameMetersController = FreeGameMetersControllerGame;
BehaviorCoreModule.FreeGameView = View;
BehaviorCoreModule.PostLoadingController = PostLoadingControllerGame;
BehaviorCoreModule.BaseController = BaseControllerGame;
BehaviorCoreModule.BaseView = BaseGameViewGame;
BehaviorCoreModule.IntroOutroController = IntroOutroControllerGame;
BehaviorCoreModule.SettingPannelController = SettingPanelController;
BehaviorCoreModule.BigWinControllerFg = BigWinControllerFgGame;
slot.SlotLogic = GameClientLogic;
slot.BaseWinPresentationController = WinPresentationControllerGame;
slot.BaseReelPanelController = ReelPanelControllerGame;
slot.BaseMetersController = MetersControllerGame;
slot.BaseButtonController = ButtonControllerGame;
BehaviorCoreModule.FreeGameView = View;
BehaviorCoreModule.FreeGameReelPanelController = FreeGameReelPanelControllerGame;
BehaviorCoreModule.BaseModel = BaseGameModel;
BehaviorCoreModule.FreeGameModel = FreeGameModel;
BehaviorCoreModule.BackgroundController = BackgroundControllerGame;
BehaviorCoreModule.FreeGameWinPresentationController = FreeGameWinPresentationControllerGame;
BehaviorCoreModule.BlurBackgroundController = BlurBackgroundControllerGame;
reelPanel.Reel = ReelGame;
reelPanel.WinReelPanel = WinPresentationPanelGame;
BehaviorCoreModule.BigWinView = BigWinViewGame;
BehaviorCoreModule.BigWinController = BigWinControllerGame;
// Free Game Retrigger
BehaviorCoreModule.RetriggerController = FreeGameRetriggerController;
BehaviorCoreModule.RetriggerView = FreeGameRetriggerView;
BehaviorCoreModule.PlayerMsgController = PlayerMsgControllerGame;
BehaviorCoreModule.TopLogoView = TopLogoViewGame;
BehaviorCoreModule.TopLogoViewFg = TopLogoViewfgGame;
BehaviorCoreModule.TopLogoControllerFg = TopLogoControllerFgGame;
BehaviorCoreModule.IntroOutroView = IntroOutroViewGame;
